import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTalentMutation, useUpdateTalent } from "../../actions/authActions";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
export default () => {
  const userData = useSelector((state) => state.app.userData.userData);
  const {
    data: talentData,
    isLoading,
    isError,
    error,
  } = useUpdateTalent(userData?.talent?.id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [projects, setProjects] = useState([
    { title: "", link: "", image: null },
  ]);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    trigger,
    watch,
    unregister,
  } = useForm({
    defaultValues: {
      projects: [{ title: "", link: "", image: null }],
    },
  });

  const mutation = useTalentMutation(
    talentData?.id,
    dispatch,
    setLoadingToapi,
    navigate
  );
  const handleAddProject = () => {
    const newIndex = projects.length;
    setProjects([...projects, { title: "", link: "", image: null }]);
    setValue(`projects.${newIndex}.title`, "");
    setValue(`projects.${newIndex}.link`, "");
  };
  const handleRemoveProject = (indexToRemove) => {
    const fields = watch(`projects`);
    // Remove project from local state
    const updatedProjects = [...fields];
    updatedProjects.splice(indexToRemove, 1);
    setProjects(updatedProjects);

    // Unregister all projects fields (clears internal state in RHF for projects array)
    unregister("projects");

    // Reset values for all remaining projects, including file input
    updatedProjects.forEach((proj, idx) => {
      setValue(`projects.${idx}.title`, proj.title);
      setValue(`projects.${idx}.link`, proj.link);
      setValue(`projects.${idx}.image`, proj.image ?? null);
    });

    // Optionally re-run validation on projects after update
    trigger("projects");
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const apiData = new FormData();
    apiData.append("stage_name", talentData?.stage_name);
    apiData.append("age", talentData?.age);
    apiData.append("gender", talentData?.gender?.gender_id);
    apiData.append("_method", "PUT");
    data.projects.forEach((project, i) => {
      apiData.append(`drama_title[${i}]`, project.title || "");
      apiData.append(`drama_external_url[${i}]`, project.link || "");
      if (projects[i]?.image) {
        apiData.append(`drama_image[${i}]`, projects[i].image);
      }
    });
    // Submit the form
    mutation.mutate(apiData);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading gallery: {error.message}</p>
      </div>
    );
  }
  return {
    handleSubmit,
    onSubmit,
    register,
    errors,
    projects,
    handleAddProject,
    handleRemoveProject,
    setProjects,
    setValue,
    control,
    loadingToapi,
  };
};
